var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLottoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_7293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 21.5833C22 21.8133 21.8133 22 21.5833 22H5.75C3.6825 22 2 20.3175 2 18.25V2.41667C2 2.18667 2.18667 2 2.41667 2C2.64667 2 2.83333 2.18667 2.83333 2.41667V18.25C2.83333 19.8583 4.14167 21.1667 5.75 21.1667H21.5833C21.8133 21.1667 22 21.3533 22 21.5833ZM17.4167 18.6667C17.6467 18.6667 17.8333 18.48 17.8333 18.25V7.41667C17.8333 7.18667 17.6467 7 17.4167 7C17.1867 7 17 7.18667 17 7.41667V18.25C17 18.48 17.1867 18.6667 17.4167 18.6667ZM14.0833 18.6667C14.3133 18.6667 14.5 18.48 14.5 18.25V11.5833C14.5 11.3533 14.3133 11.1667 14.0833 11.1667C13.8533 11.1667 13.6667 11.3533 13.6667 11.5833V18.25C13.6667 18.48 13.8533 18.6667 14.0833 18.6667ZM10.75 18.6667C10.98 18.6667 11.1667 18.48 11.1667 18.25V7.41667C11.1667 7.18667 10.98 7 10.75 7C10.52 7 10.3333 7.18667 10.3333 7.41667V18.25C10.3333 18.48 10.52 18.6667 10.75 18.6667ZM7.41667 18.6667C7.64667 18.6667 7.83333 18.48 7.83333 18.25V11.5833C7.83333 11.3533 7.64667 11.1667 7.41667 11.1667C7.18667 11.1667 7 11.3533 7 11.5833V18.25C7 18.48 7.18667 18.6667 7.41667 18.6667Z",
    fill: "#515151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_7293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLottoResults);
export default __webpack_public_path__ + "static/media/lotto-results.2fa8c8fbb70ec5158a8fe999781eb3e6.svg";
export { ForwardRef as ReactComponent };